export const FORGOT_PASSWORD_CODE_LENGTH = 6;

export const AUTH_SESSION_INACTIVE_CODE = 'SESSION_INACTIVE';

export const AUTH_PROVIDER_THROTTLED_CODE = 'AUTH_PROVIDER_THROTTLED';
export const AUTH_PROVIDER_RETRY_AFTER = {
  defaultSeconds: 10,
  maxSeconds: 3_600,
} as const;
